import { useThemeUI as s } from "theme-ui";
import { useMemo as r } from "react";
import { variants as i } from "@theme-ui/css";
import { useMatchMediaContext as u } from "./match-media-context.js";
function h(t) {
  const { theme: e } = s();
  return r(() => i(t, e), [t, e]);
}
function m(t) {
  const { theme: e } = s(), n = typeof t == "function" ? t(e) : t, { breakpointIndex: o } = u();
  return c(n, o);
}
const c = (t, e) => {
  if (e === void 0)
    return;
  const n = t[e >= t.length ? t.length - 1 : e];
  return n === null ? t.slice(0, e).reverse().find((o) => o !== null) : n;
}, v = (t) => {
  const e = m([
    "mobile",
    "tablet",
    "desktop"
  ]);
  return t ?? e;
};
export {
  c as getResponsiveValue,
  v as useLayoutVariant,
  m as useResponsiveValue,
  h as useVariants
};
